export const SEARCH_FEATURES = {
  moduleKey: 'search',
  features: ['search.global'] as const,
  featureMeta: {
    'search.global': {
      name: 'Global search',
      translations: { name: { de: 'Globale Suche', en: 'Global search', fr: 'Recherche globale', it: 'Ricerca globale' } },
    },
  },
} as const;
